import React, { Component } from "react";
import { v4 as uuidv4 } from "uuid";

// Component Import
import ButtonLoading from "../../components/buttonLoading/ButtonLoading";

// Redux stuff
import { connect } from "react-redux";
import { signup } from "../../redux/actions/providerActions";

//Styles
import styles from "./signup.module.css";

import AlbumIcon from "@material-ui/icons/Album";

class Signup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      accountType: "student",
      firstName: "",
      lastName: "",
      enrollmentNo: "",
      email: "",
      password: "",
      confirmPassword: "",
      phoneNo: "",
      branch: "",
      batch: "",
    };
  }

  render() {
    const {
      accountType,
      firstName,
      lastName,
      enrollmentNo,
      email,
      password,
      confirmPassword,
      phoneNo,
      branch,
      batch,
    } = this.state;

    const { loading } = this.props.provider;

    const onInputChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };

    const uploadData = (e) => {
      e.preventDefault();
      const data = {
        accountType: accountType,
        firstName: firstName,
        lastName: lastName,
        enrollmentNo: enrollmentNo,
        email: email,
        password: password,
        confirmPassword: confirmPassword,
        phoneNo: phoneNo,
        branch: branch,
        batch: batch,
        userId: uuidv4(),
      };

      this.props.signup(data, this.props.history);
    };

    return (
      <div
        className={styles.container}
        style={{ backgroundImage: "url(./signupBack.svg)" }}
      >
        <form onSubmit={(e) => uploadData(e)}>
          <div className={styles.card}>
            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <h1 style={{ margin: 0 }}>College-X</h1>
              </div>
              <div className={styles.formGroup}>
                <label name="accountType">
                  Account Type <AlbumIcon />
                </label>
                <select
                  name="accountType"
                  value={accountType}
                  onChange={(e) => onInputChange(e)}
                >
                  <option value="student">Student</option>
                  <option value="teacher">Teacher</option>
                </select>
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="firstName">
                  First Name <AlbumIcon />
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="text"
                  name="firstName"
                  value={firstName}
                  placeholder="Aditya"
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="lastName">
                  Last Name <AlbumIcon />
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="text"
                  name="lastName"
                  value={lastName}
                  placeholder="Gusain"
                />
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="enrollmentNo">
                  Enrollment No. / Roll No. <AlbumIcon />{" "}
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="text"
                  name="enrollmentNo"
                  value={enrollmentNo}
                  placeholder="Enrollment No."
                />
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="email">
                  Email Address <AlbumIcon />{" "}
                  <span>(Use College Provider E-mail ID)</span>
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="text"
                  name="email"
                  value={email}
                  placeholder="username@domain.com"
                />
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="password">
                  Password <AlbumIcon />
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="password"
                  name="password"
                  value={password}
                  placeholder="Enter Password"
                />
              </div>
              <div className={styles.formGroup}>
                <label htmlFor="confirmPassword">
                  Comfirm Password <AlbumIcon />
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="password"
                  name="confirmPassword"
                  value={confirmPassword}
                  placeholder="Enter Password again"
                />
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="phoneNo">
                  Phone No. <AlbumIcon />
                </label>
                <input
                  onChange={(e) => onInputChange(e)}
                  type="text"
                  name="phoneNo"
                  value={phoneNo}
                  placeholder="1234567890"
                />
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="branch">
                  Branch
                  <AlbumIcon />
                </label>
                <select name="branch" onChange={(e) => onInputChange(e)}>
                  <option value="Select Branch">Select Branch</option>
                  <option value="CSE">CSE</option>
                  <option value="ECE">ECE</option>
                  <option value="IT">IT</option>
                </select>
              </div>
            </div>

            <div className={styles.formGroupForTwo}>
              <div className={styles.formGroup}>
                <label htmlFor="batch">
                  Batch <AlbumIcon /> <span>(Year of passing)</span>
                </label>
                <select name="batch" onChange={(e) => onInputChange(e)}>
                  <option value="Select Batch">Select Batch</option>
                  <option value={2021}>2021</option>
                  <option value={2022}>2022</option>
                  <option value={2023}>2023</option>
                  <option value={2024}>2024</option>
                  <option value={2025}>2025</option>
                  <option value={2026}>2026</option>
                </select>
              </div>
            </div>

            <div className={styles.submitButtonContainer}>
              <button
                type="submit"
                className={styles.submitButton}
                disabled={loading ? true : false}
              >
                {loading ? (
                  <ButtonLoading width="16px" height="16px" />
                ) : (
                  "Signup"
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  provider: state.provider,
});

export default connect(mapStateToProps, { signup })(Signup);
